import { isMember } from "../utils"


const memberLinks = [
	{
		gameRule: "feedback-auditorium",
		gameRuleCooldown: 1000*60*60,
		height: "15.7%",
		href: "https://isfcongress.tkeventsregistration.com/ffauditorium",
		isExternal: true,
		label: "Feedback",
		left: "42.3%",
		target: "_blank",
		top: "80.9%",
		width: "7.6%",
	},
	{
		height: "15.7%",
		href: "/roundtables",
		label: "Roundtable Sessions",
		left: "50.3%",
		top: "80.9%",
		width: "7.6%",
	},
]

export default {
	background: "https://assets.swoogo.com/uploads/full/1386546-615761c078a8e.jpg",
	extras: (
		<>
			<iframe
				className="auditorium-livestream"
				src="https://livestream.com/accounts/11603075/events/9889539/player?width=640&height=360&enableInfoAndActivity=false&defaultDrawer=&autoPlay=true&mute=false"
				allowfullscreen
			/>
		</>
	),
	links: [
		{
			height: "66.1%",
			label: "Livestream",
			left: "21%",
			top: "0.3%",
			width: "58.2%",
		},
		...(isMember ? memberLinks : []),
	],
	name: "auditorium",
}
